import client from './client';

export const usersApi = {
  getAll: (params) => client.get('/users', { params }),
  getById: (id) => client.get(`/users/${id}`),
  getDetails: (id) => client.get(`/users/${id}/details`),
  getNavigationHistory: (id) => client.get(`/users/${id}/navigation-history`),
  create: (data) => client.post('/users', data),
  update: (id, data) => client.put(`/users/${id}`, data),
  delete: (id) => client.delete(`/users/${id}`)
};
